/**
 * Component common-heading-hero JS
 *
 * !!! Uncomment only if component is needed, this way the compiler will ignore useless files
 */
 
jQuery(document).ready(function () {
    const component = jQuery('.common-heading-hero');
    
    if (!component.length) {
        return;
    }

    jQuery('.common-heading-hero__icon a', component).bind('click', function (e) {

        const currentHero = jQuery(this).closest('.common-heading-hero');

        const nextComponent = currentHero.next();

        if (nextComponent.length) {
            nextComponent[0].scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    });


});